export const marketAddresses = {
  56: '0x4e05C992Ca46F2B1fCF17884BFB4aB59c0F900a1',
  97: '0xc8DBd2edC8F8Ee43958cAa08bb9A3D32E3E5E0c2'
}

export const vestingPoolAddresses = {
  56: '0x2Fe875EB241F435C36fb3a9B6E8BcD2dD7EAbf11',
  97: '0x57323748Ac32135b4964Bb18c66770f0Ac283Cd7'
}